import SearchOptions from '../components/search-options'
import LocationRealTime from '../components/location-real-time'

export default {
  SearchOptions,
  LocationRealTime
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/components.js